export default {
  buy_desc_1: '1000 以上のブロックチェーンに対応',
  buy_desc_2: 'BTC・ETH・TRON・BSC などの EVM パブリックチェーンを含む',
  buy_desc_3: '1 台であらゆる暗号資産を管理',

  features: '特長',
  features_title_1: 'MCU+SE セキュリティチップ',
  features_desc_1: 'ミリタリーグレードのチップでセキュリティを保証',
  features_title_2: '2.0 インチ LCD 画面',
  features_desc_2: '取引の詳細をより明確に表示。見たまま署名',
  features_title_3: 'Bluetooth 接続',
  features_desc_3: 'データ脱感作通信',
  features_title_4: '多層プロテクション',
  features_desc_4: 'オフライン・PIN コード・識別済み接続',
  color: 'カラー',
  free_shipping: '送料無料',

  break_down_desc_1: 'LEFT ボタン',
  break_down_desc_2: '画面で左へ移動／前のページに戻る',
  break_down_desc_3: 'OK ボタン',
  break_down_desc_4: '操作を確定、またはメニューに入る。長押しで電源オン／オフ',
  break_down_desc_5: 'UP ボタン',
  break_down_desc_6: '画面で上へ移動',
  break_down_desc_7: 'RIGHT ボタン',
  break_down_desc_8: '画面で右へ移動／操作を確定',
  break_down_desc_9: 'DOWN ボタン',
  break_down_desc_10: '画面で下へ移動',

  display_title: 'ディスプレイ',
  display_desc: '2 インチ LCD ディスプレイ',
  battery_title: 'バッテリー',
  battery_desc: '100mAh',
  materials_title: '素材',
  materials_desc: 'アルミ合金',
  dual_chip_title: 'デュアルチップ',
  dual_chip_desc: 'MCU + SE セキュリティチップ',

  easy_and_safe_title: '簡単かつ安全',
  easy_and_safe_desc: '簡単に接続・操作でき、暗号資産を安全に保護',
  easy_and_safe_list_1: 'デュアルチップ',
  easy_and_safe_list_2: 'MCU + SE セキュリティチップ',
  easy_and_safe_list_3: 'かんたん接続',
  easy_and_safe_list_4: 'Bluetooth と Type-C',
  easy_and_safe_list_5: '2 インチディスプレイ',
  easy_and_safe_list_6: '見たまま署名',

  product_specifications: '製品仕様',
  detail_center: 'USB Type-C',
  detail_left_1: 'アルミ合金シェル：ウォレットを損傷から保護',
  detail_left_2: 'LEFT ボタン',
  detail_left_3: 'DOWN ボタン',
  detail_right_1: '2 インチディスプレイ：関連する取引を表示',
  detail_right_2: 'UP ボタン',
  detail_right_3: 'RIGHT ボタン',
  detail_right_4: 'OK ボタン',

  keypal_card_1: 'サイズ',
  keypal_card_label_1: '91mm*55mm*6.7mm',
  keypal_card_2: '電源とバッテリー',
  keypal_card_label_2: '100mAh リチウムイオン電池',
  keypal_card_3: '接続',
  keypal_card_label_3: 'Bluetooth & Type-C',
  keypal_card_4: '素材',
  keypal_card_label_4: 'アルミ合金、プラスチック',
  keypal_card_5: '重量',
  keypal_card_label_5: '53g',
  keypal_card_6: 'ディスプレイ',
  keypal_card_label_6: '2 インチ LCD ディスプレイ',
  keypal_card_7: 'チップ',
  keypal_card_label_7: 'MCU+SE',
  keypal_card_8: '認証',
  keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

  package: '同梱物',
  package_line_1: 'ハードウェアウォレット 1 台',
  package_line_2: 'USB Type-C ケーブル 1 本',
  package_line_3: 'リカバリーシート 2 枚',
  package_line_4: 'ステッカー 1 枚',

  keypal_plus: {
    larger_battery: 'バッテリー容量 200% アップ',

    keypal_card_1: 'サイズ',
    keypal_card_label_1: '91mm*55mm*9.0mm',
    keypal_card_2: '電源とバッテリー',
    keypal_card_label_2: '300mAh リチウムイオン電池',
    keypal_card_3: '接続',
    keypal_card_label_3: 'Bluetooth & Type-C',
    keypal_card_4: '素材',
    keypal_card_label_4: 'アルミ合金、プラスチック',
    keypal_card_5: '重量',
    keypal_card_label_5: '63g',
    keypal_card_6: 'ディスプレイ',
    keypal_card_label_6: '2 インチ LCD ディスプレイ',
    keypal_card_7: 'チップ',
    keypal_card_label_7: 'MCU+SE',
    keypal_card_8: '認証',
    keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

    color: 'カラー',
    color_desc: 'ブラック、シルバー、ゴールド',
    battery: 'バッテリー',
    battery_desc: '300 mAh',
    left: '左',
    down: '下',
    right: '右',
    up: '上',
    ok: 'OK',
    center: 'USB Type-C',
    left_1: 'LEFT ボタン',
    left_2: '画面で左へ移動／前のページに戻る',
    left_3: 'DOWN ボタン',
    left_4: '画面で下へ移動',
    right_1: 'UP ボタン',
    right_2: '画面で上へ移動',
    right_3: 'RIGHT ボタン',
    right_4: '画面で右へ移動／操作を確定',
    right_5: 'OK ボタン',
    right_6: '操作を確定、またはメニューに入る。長押しで電源オン／オフ',
    mobile_center: 'Type-C',
    mobile_center_2: '充電およびファームウェア更新用',
  },
};
